<template>
  <v-app v-resize="onResize">
    <v-toolbar app>
      <v-toolbar-title class="headline text-uppercase title" v-if="!buscadorAbierto">
        <v-btn    
        color="secondary"  
        class="btnMenu"          
        id="headline"
        flat       
        @click="toggleMenu()"        
        >
        <v-icon>view_headline</v-icon>
        </v-btn>
        <span v-if="!$store.state.appconfig.showLogoImg" @click="gohome">{{$store.state.appconfig.appname1}}</span>
        <span v-if="$store.state.appconfig.showAppSufix && !$store.state.appconfig.showLogoImg" class="font-weight-light">{{$store.state.appconfig.appname2}}</span>  
        <img class="logoImg" v-if="$store.state.appconfig.showLogoImg && windowSize.x > 960"  src="logo.png"/>  
        <img class="logoImgSmall" v-if="$store.state.appconfig.showLogoImg && windowSize.x <= 960"  src="logosmall.png"/>  
      </v-toolbar-title>      
      
      <toolbar class="toolbarClass" v-if="$store.state.usuarioLogeado && !buscadorAbierto"/>                   
      <v-spacer></v-spacer>     
      <v-flex xs2 v-if="!searchLarge && $store.state.usuarioLogeado && (isMenu)">
        <v-btn class="searchButton" flat @click="openSearch">     
        <v-icon>search</v-icon>
        </v-btn>
      </v-flex>
      <v-flex v-if="searchLarge && $store.state.usuarioLogeado ">
        <v-text-field  
          ref="search"        
          class="ml-2" 
          v-model="filter" 
          label="Buscar artículo..." 
          append-icon="clear"             
          @click:append="clearSearchField"
          hide-details         
          @change="getItems"
          @keyup="setSearchTimeout"
          ></v-text-field>
      </v-flex>
      <v-flex v-if="$store.state.usuarioLogeado" sm2 text-sm-right hidden-xs-only>
        Hola, {{$store.state.usuario.nombre}}<br/>
        <span class="versionText">ver. {{$store.state.appversion}}</span>
      </v-flex>     
      
      <v-menu v-if="$store.state.usuarioLogeado" offset-y>
      <template v-slot:activator="{ on }">
        <v-btn
           fab dark small color="primary" class="elevation-5"                    
          v-on="on"
        >
          <v-icon large color="primary darken-4">account_circle</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-tile
          v-for="(menuitem, index) in dropdownItems"
          :key="index"
          @click="navigate(menuitem.id)"
        >
          <v-list-tile-title>{{ menuitem.title }}</v-list-tile-title>
        </v-list-tile>

        <v-list-tile          
           @click="logout()"
        >
          <v-list-tile-title>Salir</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>

      <!--v-btn v-if="$store.state.usuarioLogeado" fab dark small color="blue" class="elevation-5" @click="logout()">
        <v-icon large dark>power_settings_new</v-icon>
      </v-btn-->
      <!--v-btn v-if="!$store.state.usuarioLogeado" flat href="https://github.com/vuetifyjs/vuetify/releases/latest" target="_blank">
        <span class="mr-2">Iniciar Sesión</span>
      </v-btn-->
    </v-toolbar>                     
    <systembar class="systembarFix" v-if="$store.state.usuarioLogeado"/> 
    <v-content id="appContent">                  
        <selectorComercial/>        
        <globalConfirmDialog/>
        <globalDialog/>
        <calEventDialog/>
        <dialogCustInfo/>
        <loader/>
        <dialogLastOrder/>
        <router-view/>      
    </v-content>
  </v-app>
</template>

<script>
import loader from "./components/loader";
import toolbar from "./components/toolbar";
import globalDialog from "./components/globalDialog";
import globalConfirmDialog from "./components/globalConfirmDialog";
import selectorComercial from "./components/selectorComercial";
import calEventDialog from "./components/calEventDialog";
import dialogCustInfo from '@/components/dialogCustInfo.vue';
import systembar from "@/components/systembar";
import dialogLastOrder from "./components/dialogLastOrder";
//import mixin from './components/mixin.js';

export default {
  //mixins:[mixin],
  name: "App",
  components: {  
    loader,  
    toolbar,
    globalDialog,
    globalConfirmDialog,
    selectorComercial,
    calEventDialog,
    dialogCustInfo,
    dialogLastOrder,
    systembar  
  },
  data() {
    return {
      
      lastx : 0,
      dropdownItems: [
        { title: 'Análisis Objetivos', id: 4 },
      ],
    };
  },
  methods:{
    gohome(){
      if (this.$store.state.usuarioLogeado){
        this.$router.push('menu')
      } else{
        this.$router.push('/')
      }
    },
    logout(){
      this.$store.commit("logout");
    },
    toggleMenu(){
      //https://vuetifyjs.com/en/customization/breakpoints
      this.windowSize = { x: window.innerWidth, y: window.innerHeight }
      this.menuLateralDrawer = !this.menuLateralDrawer;    
      /*if (this.windowSize.x >= 600){
          this.menuLateralDrawer = !this.menuLateralDrawer;                        
          this.menuVerticalDrawer = true;
      } else {
          this.menuLateralDrawer = true;                        
          this.menuVerticalDrawer = !this.menuVerticalDrawer;
      }*/
    },
    clearSearchField(){
      this.filter = '';
      this.getItems();
      if (this.windowSize.x >= 850) this.searchLarge = true;
      else this.searchLarge = false;
      this.buscadorAbierto = false; 
    },
    setSearchTimeout(){
      var thisaux = this;
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(function(){
              thisaux.resetCategories();
              thisaux.resetOpts();
              thisaux.getItems();
              //if (thisaux.windowSize.x >= 850) thisaux.searchLarge = true;
              //else thisaux.searchLarge = false;
              //thisaux.buscadorAbierto = false; 
      }, 800);
      clearTimeout(this.searchTimeout2);
      this.searchTimeout2 = setTimeout(function(){
              if (thisaux.windowSize.x >= 850) thisaux.searchLarge = true;
              else thisaux.searchLarge = false;
              thisaux.buscadorAbierto = false; 
      }, 5000);
    },
    resetCategories(){
      this.$store.state.menuitems[0].selectedItems = [];
        for (var i = 0; i < this.menuitems[0].items.length; i++){
            this.menuitems[0].items[i].allow = false;
            this.menuitems[0].items[i].active = false;
            if (this.menuitems[0].items[i].subCategories){
                for (var j = 0; j < this.menuitems[0].items[i].subCategories.length; j++){
                    this.menuitems[0].items[i].subCategories[j].allow = false;
                }
            }
        }
    },
    resetOpts(){
        this.$store.state.orderbygroup = false;
        this.$store.state.topventas = false;
        this.$store.state.onlyAvailable = false;
        this.$store.state.onlyPromos = false;
    },
    onResize () {
        this.windowSize = { x: window.innerWidth, y: window.innerHeight }   
      
    } ,
    openSearch(){
      this.buscadorAbierto = true;
      this.searchLarge = true;   
      this.menuLateralDrawer = false;      
    }
  },
  watch:{        
        windowSize: function(val){
          if (this.lastx != this.windowSize.x){
            if (this.windowSize.x >= 850){
              this.searchLarge = true;
              this.buscadorAbierto = false;
            } else {
              this.searchLarge = false;
              this.buscadorAbierto = false;            
            }
          }
          this.lastx = this.windowSize.x;
            /*if ((this.windowSize.x >= 600) && (!this.menuVerticalDrawer)) {
                this.menuVerticalDrawer = true;
                this.menuLateralDrawer = false;
            }
            if ((this.windowSize.x < 600) && (!this.menuLateralDrawer)) {
                this.menuVerticalDrawer = false;
                this.menuLateralDrawer = true;
            }*/
        }
    },
    computed:{
      isMenu:{
        get(){
                return this.$store.state.isMenu;
            },
      },
      windowSize:{
        get(){
                return this.$store.state.windowSize;
            },
            set(value){
                this.$store.state.windowSize = value;
            }
      },
      menuLateralDrawer:{
            get(){
                return this.$store.state.menuLateralDrawer;
            },
            set(value){
                this.$store.state.menuLateralDrawer = value;
            }
        },
        menuVerticalDrawer:{
            get(){
                return this.$store.state.menuVerticalDrawer;
            },
            set(value){
                this.$store.state.menuVerticalDrawer = value;
            }
        },
        menuitems:{
            get(){
                return this.$store.state.menuitems;
            }
        },
        navMenu:{
            get() {
                return this.$store.state.navMenu;
            },
            set(value){
                this.$store.commit('setNavMenu', value)
            }
        },
        filter: {
            get(){
                return this.$store.state.filter;
            },
            set(value){
                this.$store.commit('setItemsFilter', value);
            }
        },
        searchLarge:{
            get() {
                return this.$store.state.searchLarge;
            },
            set(value){
                this.$store.commit('setSearchLarge', value)
            }
        },
        buscadorAbierto:{
            get() {
                return this.$store.state.buscadorAbierto;
            },
            set(value){
                this.$store.commit('setBuscadorAbierto', value)
            }
        }
    },
  created(){
    this.getAppConfig();
  }
};
</script>
<style>
.logoImg{
  height: 60px;
  
}
.logoImgSmall{
  max-width: 80px;
  
}
/* width */
::-webkit-scrollbar {
  width: 7px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1; 
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: #888; 
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555; 
}
#appContent{
  margin-top: 15px;   
  height: 50%;
  padding: 70px 0px 0px !important;
}
#headline{
  padding: 0;
  margin: 0px;
  min-width: 10px;  
}


.versionText{
  color:#999;
  font-size: small;
}
@media (max-width: 3840px) {
  .btnMenu{
    margin-top: -45px !important;
  }
  .toolbarClass{
    margin-left: 3%
  }
  .title{
    min-width: 150px;
  }
  .systembarFix{
    margin-top: 64px;
    position: fixed;
    width: 100%;
    z-index: 1;
  }
}
@media (max-width: 960px) {
  .btnMenu{
    margin-top: 0px !important;
  }
  .toolbarClass{
    margin-left: 0%
  }
  .title{
    min-width: 120px;
  }
  .systembarFix{
    margin-top: 56px;
    position: fixed;
    width: 100%;
    z-index: 1;
  }
}
.searchButton{
    padding: 0px;
    margin: 0px;
    min-width: 32px !important;
  }
</style>
